import { Button, Card, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { QuestionGroup, QuestionGroupsMap } from '../../types/QuestionGroup';
import { useSetRecoilState } from 'recoil';
import { questionGroupState } from '../../states/questionGroupState';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

type PaginationState = {
  cursor: string | null;
  hasMore: boolean;
};

type PaginationMap = {
  beginner: PaginationState;
  easy: PaginationState;
  normal: PaginationState;
  hard: PaginationState;
};

type Props = {
  activeTabKey: string;
  onTabChange: (key: string) => void;
  questionGroupsMap?: QuestionGroupsMap;
  loading: boolean;
  loadingMore: boolean;
  paginationMap: PaginationMap;
  loadMore: (difficulty: 'beginner' | 'easy' | 'normal' | 'hard') => void;
};

const QuestionGroupsTableSP: React.FC<Props> = ({
  activeTabKey,
  onTabChange,
  questionGroupsMap,
  loading,
  loadingMore,
  paginationMap,
  loadMore,
}) => {
  const setQuestionGroup = useSetRecoilState(questionGroupState);
  const navigate = useNavigate();

  const columns: ColumnsType<QuestionGroup> = [
    {
      key: 'key',
      render: (_, record) => (
        <FlexBox>
          <Row>
            <Head></Head>
            <Value>{record.name}</Value>
          </Row>
          <Row>
            <Head>時間成績：</Head>
            <Value>{record.bestScoreLabel?.time}</Value>
          </Row>
          <Row>
            <Head>正解率：</Head>
            <Value>{record?.bestScoreLabel?.accuracy}</Value>
          </Row>
          <Row>
            <Head>総合成績：</Head>
            <Value>{record?.bestScoreLabel?.total}</Value>
          </Row>
          <Button
            onClick={() => {
              setQuestionGroup(record);
              navigate('/time-attack');
            }}
          >
            問題を解く
          </Button>
        </FlexBox>
      ),
    },
  ];

  const renderTable = (difficulty: 'beginner' | 'easy' | 'normal' | 'hard') => (
    <>
      <Table
        columns={columns}
        showHeader={difficulty === 'beginner' ? undefined : false}
        dataSource={questionGroupsMap?.[difficulty]}
        loading={loading}
        pagination={false}
      />
      {paginationMap[difficulty].hasMore && (
        <LoadMoreContainer>
          <Button onClick={() => loadMore(difficulty)} loading={loadingMore}>
            もっと見る
          </Button>
        </LoadMoreContainer>
      )}
    </>
  );

  const exerciseCorses: Record<string, React.ReactNode> = {
    beginner: renderTable('beginner'),
    easy: renderTable('easy'),
    normal: renderTable('normal'),
    hard: renderTable('hard'),
  };

  interface Level {
    key: string;
    tab: string;
  }

  const level: Level[] = [
    {
      key: 'beginner',
      tab: '入門',
    },
    {
      key: 'easy',
      tab: '初級',
    },
    {
      key: 'normal',
      tab: '中級',
    },
    {
      key: 'hard',
      tab: '上級',
    },
  ];

  return (
    <StyledCard
      tabList={level}
      activeTabKey={activeTabKey}
      onTabChange={(key) => onTabChange(key)}
    >
      {exerciseCorses[activeTabKey]}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  width: 90vw;
  min-width: 350px;
`;

const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

const Row = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
  margin-bottom: 15px;
`;

const Head = styled.div`
  flex-basis: 40%;
`;

const Value = styled.div`
  flex-basis: 60%;
`;

const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`;

export default QuestionGroupsTableSP;
